import { apiFetch } from '@/lib/api';
import type { BulkRenameArgs, AssetRename, BulkRenameResult } from '@kagami/shared/bulkRename';
export type { BulkRenameArgs, AssetRename, BulkRenameResult };

async function postBulkRename(
    showId: string,
    path: 'bulk-rename' | 'bulk-rename/preview',
    { assetIds, format, startIndex, time }: BulkRenameArgs,
): Promise<BulkRenameResult> {
    const response = await apiFetch(`/api/shows/${showId}/assets/${path}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ assetIds, format, startIndex, time }),
    });
    if (!response.ok) throw new Error('Failed to bulk rename assets');
    return response.json();
}

export function previewBulkRename(showId: string, args: BulkRenameArgs): Promise<BulkRenameResult> {
    return postBulkRename(showId, 'bulk-rename/preview', args);
}

export function commitBulkRename(showId: string, args: BulkRenameArgs): Promise<BulkRenameResult> {
    return postBulkRename(showId, 'bulk-rename', args);
}
